










































































































import {
  Component, mapState, Watch, mixins, Prop,
} from '@samclick-commons';
import SamclickMixins from '@/utils/mixins';
import {
  CommonsStore, AuthorizationStore, AdvertisementsStore, Payload,
} from '@samclick-store-factory';
import { extractSRC } from '@/utils/common-utils';
import { _isEmpty, _filter } from '@samclick-lodash';

// MODIFIED: Added all media types
const bannerType = new Map([
  [16, 'Banners'],
  [2, 'Text Link'],
  [4, 'Image Link'],
  [8, 'Email Template'],
]);

class AdsDetailState {
  public campaign: string = ''
  public landingPage: string = ''
  public isTinyURL: boolean = false
  public showCopiedTooltip: boolean = false
}

@Component({
  computed: {
    ...mapState({
      campaignList: (state: any) => state.advertisements.advertisementsStore.campaignList,
      landingPages: (state: any) => state.advertisements.advertisementsStore.landingPages,
    }),
  },
  props: {
    rowNumber: { type: Number, required: true },
    adsDtl: { type: Object, required: true },
  }
})
export default class AdsDetail extends mixins(SamclickMixins) {
  state = new AdsDetailState();

  // MODIFIED: Added constants for all media types
  BANNER_FLOW = 16;
  TEXT_LINK = 2;
  IMAGE_LINK = 4;
  EMAIL_TEMPLATE = 8;

  API_URL = process.env.VUE_APP_BASE_API_URL;
  UAPI_URL = process.env.VUE_APP_AFF_API_URL;
  TINY_URL = "https://tinyurl.com";

  campaignList!: [];
  landingPages!: [];

  get affCode() {
    return AuthorizationStore.currentLoggedUserInState.affiliate_code;
  }

  @Watch('campaignListFilter', { immediate: true })
  campaignListFilterWatcher(newCampaignList: any) {
    if (!_isEmpty(newCampaignList)) {
      this.state.campaign = newCampaignList[0].id;
    }
  }

  @Watch('landingPagePerCasino', { immediate: true })
  landingPagePerCasinoWatcher(newLandingPagePerCasino: any) {
    if (!_isEmpty(newLandingPagePerCasino)) {
      this.state.landingPage = newLandingPagePerCasino[0].id;
      this.updateIsTinyURL(this.state.landingPage);
    }
  }

  @Watch('state.landingPage')
  onLandingPageChange(newId: string | number | null) {
    this.updateIsTinyURL(newId);
  }

  getBannerType(type: number) {
    return bannerType.get(type) || 'Unknown';
  }

  getCategoryTypeDescription(category: number) {
    return CommonsStore.advertisementCategoryName(category);
  }

  // UNCHANGED: Kept your original working function
  updateIsTinyURL(selectedId: string | number | null) {
    const selectedObject = this.selectedLandingPageObject;
    if (selectedObject && selectedObject.isTinyURL) {
      this.state.isTinyURL = selectedObject.isTinyURL;
    } else {
      this.state.isTinyURL = false;
    }
  }

  formatCountryNames(countries: any[]) {
    if (!countries) return '';
    return countries.map((country) => country.country_name).join(', ');
  }

  // Computed properties for type checking
  get isBanner() { return this.adsDtl.type === this.BANNER_FLOW; }
  get isTextLink() { return this.adsDtl.type === this.TEXT_LINK; }
  get isImageLink() { return this.adsDtl.type === this.IMAGE_LINK; }
  get isEmail() { return this.adsDtl.type === this.EMAIL_TEMPLATE; }

  get selectedLandingPageObject(): any | null {
      if (this.state.landingPage === null || this.state.landingPage === undefined || !this.landingPagePerCasino) {
          return null;
      }
      return this.landingPagePerCasino.find((item: any) => item.id === this.state.landingPage) || null;
  }

  get directLink() {
    return (isLp: boolean) => {
      const { id } = this.adsDtl;
      const { landingPage, campaign } = this.state;
      const base = this.state.isTinyURL ? `${this.TINY_URL}/infiaff` : `${this.API_URL}/go/redirect`;
      return `${base}?bid=${id}&lid=${landingPage}&aid=${this.affCode}&cid=${campaign}`;
    };
  }

  // MODIFIED: Renamed from textLink to generatedCode and updated to handle all types
  get generatedCode() {
    const { text, type, id, name, file_name } = this.clone(this.adsDtl);
    const { campaign, landingPage } = this.state;

    if (!campaign || !landingPage) {
      console.error("Returning blank");
      return '';
    }
    const trackingLink = this.directLink(false);

    switch (type) {
      case this.BANNER_FLOW:
        const target = encodeURIComponent(trackingLink);
        const srcLink = `${this.API_URL}/go/bannerflow?bid=${id}&lid=${landingPage}&aid=${this.affCode}&cid=${campaign}&aff_view=0&targeturl=${target}`;
        return `<script type="text/javascript" charset="UTF-8" src="${srcLink}" async><\/script>`;
      case this.TEXT_LINK:
        return `<a href="${trackingLink}" target="_blank">${text}</a>`;
      case this.IMAGE_LINK:
        return `<a href="${trackingLink}" target="_blank"><img src="${this.UAPI_URL}/pub/media/${file_name}?bid=${id}&lid=${landingPage}&aid=${this.affCode}&cid=${campaign}" alt="${name}" /></a>`;
      case this.EMAIL_TEMPLATE:
        return text.replace(/\[aff_link\]/g, `<a href="${trackingLink}" target="_blank">${trackingLink}</a>`);
      default:
        return '';
    }
  }

  get generatedImagePreviewCode() {
    const { text, type, id, name, file_name } = this.clone(this.adsDtl);
    const { campaign, landingPage } = this.state;

    if (!campaign || !landingPage) {
      console.error("Returning blank");
      return '';
    }
    const trackingLink = this.directLink(false);

    return `<a href="${trackingLink}" target="_blank"><img src="${this.UAPI_URL}/pub/media/${file_name}" alt="${name}" /></a>`;
  }

  get landingPagePerCasino() {
    const { casino, advertisementCategoryId, countries: adDtlCountries } = this.adsDtl;
    const { landingPages } = this;
    const adDtlCountryIds = Array.isArray(adDtlCountries) ? adDtlCountries.map(c => c.id) : [];

    return this.landingPages.filter((lp: any) => {
      const matchesCasinoAndCategory = lp.casinoId === casino.id;
      const lpHasNoCountries = !lp.countries || lp.countries.length === 0;
      const hasMatchingCountry = Array.isArray(lp.countries) && lp.countries.some((lpCountry: any) => adDtlCountryIds.includes(lpCountry.id));
      return matchesCasinoAndCategory && (lpHasNoCountries || hasMatchingCountry);
    });
  }

  get campaignListFilter() {
    return this.campaignList;
  }

  getIframeContent() {
    if (this.isBanner) {
      const src = extractSRC(this.adsDtl.text);
      if (src) {
        const body = document.createElement('body');
        body.style.margin = '0';
        const script = document.createElement('script');
        script.setAttribute('src', src);
        body.appendChild(script);
        return body.outerHTML;
      }
      return ''; // Return empty if banner src can't be extracted
    }

    if (this.isEmail || this.isTextLink ) {
      return (this.state.landingPage && this.state.campaign)
        ? this.generatedCode
        : `<html><body style="font-family: sans-serif; padding: 10px;">${this.$t('media.lbl_link_warning')}</body></html>`;
    }

    if (this.isImageLink) {
      return (this.state.landingPage && this.state.campaign)
        ? this.generatedImagePreviewCode
        : `<html><body style="font-family: sans-serif; padding: 10px;">${this.$t('media.lbl_link_warning')}</body></html>`;
    }

    // Default case, return nothing
    return '';
  }

  adjustIframeHeight() {
      const iframe = this.$refs['iframe' + this.rowNumber] as HTMLIFrameElement;
      if (iframe && iframe.contentWindow) {
          iframe.style.height = iframe.contentWindow.document.body.scrollHeight + 'px';
      }
  }

  // In AdsDetail.vue -> <script> -> AdsDetail class
  async copyGeneratedCode() {
    const codeToCopy = this.generatedCode;
    
    if (!codeToCopy || codeToCopy === this.$t('media.lbl_link_warning')) {
      return;
    }

    try {
      await navigator.clipboard.writeText(codeToCopy);
      
      // Show the tooltip
      this.state.showCopiedTooltip = true;
      
      // Hide it after 1.5 seconds
      setTimeout(() => {
        this.state.showCopiedTooltip = false;
      }, 1500);

    } catch (err) {
      console.error("Failed to copy code: ", err);
    }
  }
}
